<template>
  <div class="mx-auto pa-5 w-75">
    <h1 class="text-white">
      2026年4月23日発売！！
    </h1>
  </div>

  <!-- <SubTitle :TitleName="'PV'" />
  <Movie /> -->
</template>

<script>
  //import SS from "./ScreenShot.vue";
  //import SubTitle from "./SubTitle.vue";
  //import Movie from "./YouTube.vue";

  // export default {
  //   name: "App",
  //   components: {
  // SS,
  //SubTitle,
  // Movie,
  //   },
  // };
</script>
